// extracted by mini-css-extract-plugin
module.exports = {"footerText":"_36QqDunFikNoVpgdN4WcsQ","footerTextButton":"_3108vPBU6shGVACTYcYcw1"};